import { ApiError } from "./api.js";

const CODE_MESSAGES: Record<string, string> = {
  INVALID_SECTION: "That section could not be saved. Check the section name.",
  INVALID_SECTIONS: "One or more sections could not be saved.",
  INVALID_SUBGROUPS: "Check subgroup names and items.",
  INVALID_ITEMS: "One or more items could not be saved.",
  INVALID_KIND: "Kind must be Packing or To-do.",
  INVALID_NAME: "Enter a name.",
  LIMIT_EXCEEDED: "Something exceeded size limits.",
  STALE_VERSION: "Someone else changed this — reload to see their changes.",
  FORBIDDEN: "You no longer have permission to edit this.",
  LIST_NOT_FOUND: "One of the selected lists no longer exists. Remove it and try again.",
  INVITATION_CHANGED: "That invitation changed while you were working. Reload and try again.",
  MEMBER_CHANGED: "That person's access changed while you were working. Reload and try again.",
  LINK_MANAGED_BY_INVITATION: "This link belongs to an email invitation. Manage it from the People tab.",
  DECISION_ALREADY_USED: "This request was already decided.",
  DECISION_CONFLICT: "This request changed while you were deciding. Reload and try again.",
  TOO_MANY_SHARE_LINKS: "This has the maximum number of share links. Revoke one first.",
  MEMBER_NOT_FOUND: "That person no longer has access.",
  INVITATION_NOT_FOUND: "That invitation no longer exists.",
};

export function humanizeApiError(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    if (err.status === 403) return CODE_MESSAGES.FORBIDDEN;
    const code = err.code ?? err.message;
    if (code && CODE_MESSAGES[code]) return CODE_MESSAGES[code];
    if (code && /^[A-Z][A-Z0-9_]+$/.test(code)) return fallback;
    if (err.message && !/^[A-Z][A-Z0-9_]+$/.test(err.message)) return err.message;
  }
  return fallback;
}
